// Central place for the staff access/refresh token storage.
//
// Default (REACT_APP_COOKIE_ONLY_AUTH unset/false): tokens are kept in localStorage exactly as before.
// Cookie-only mode (REACT_APP_COOKIE_ONLY_AUTH=true): tokens live in memory only and are never written to
// localStorage, so an XSS payload cannot read them. The backend already sets HttpOnly auth cookies on login
// and accepts them on every request (plus the CSRF header the api client already sends), and reloads restore the
// session through GET /auth/me and POST /auth/refresh-token using those cookies.
const COOKIE_ONLY = process.env.REACT_APP_COOKIE_ONLY_AUTH === 'true';
const SENSITIVE_KEYS = new Set(['lis_access_token', 'lis_refresh_token']);
const memory = {};

if (COOKIE_ONLY && typeof window !== 'undefined') {
  try {
    SENSITIVE_KEYS.forEach((key) => window.localStorage.removeItem(key));
  } catch (e) {
    // storage unavailable - nothing to purge
  }
}

export const isCookieOnlyAuth = () => COOKIE_ONLY;

export function getToken(key) {
  if (COOKIE_ONLY && SENSITIVE_KEYS.has(key)) return memory[key] ?? null;
  return localStorage.getItem(key);
}

export function setToken(key, value) {
  if (COOKIE_ONLY && SENSITIVE_KEYS.has(key)) {
    memory[key] = value;
    return;
  }
  localStorage.setItem(key, value);
}

export function removeToken(key) {
  delete memory[key];
  localStorage.removeItem(key);
}
